import Vue from 'vue'
import TextHighlight from 'vue-text-highlight'

Vue.component('TextHighlight', TextHighlight)
